import { atom } from "recoil";
export const dashboardData = atom({
    key: "dashboardData", // unique ID (with respect to other atoms/selectors)
    default: [], // default value (aka initial value)
});
